import {h, Fragment} from "preact"
export default function IconBag () {
    return (
        <svg aria-hidden="true" role="presentation" class="icon icon-bag" viewBox="0 0 32 32">
            <path class="fill" d="M29.47,32H2.53c-.24,0-.46-.1-.62-.27-.16-.17-.24-.41-.22-.64l1.68-20.21c.04-.44.4-.77.84-.77h4.21v-2.53c0-4.18,3.4-7.58,7.58-7.58s7.58,3.4,7.58,7.58v2.53h4.21c.44,0,.8.34.84.77l1.68,20.21c.02.24-.06.47-.22.64-.16.17-.38.27-.62.27ZM3.44,30.32h25.12l-1.54-18.53h-3.44v2.53c0,.47-.38.84-.84.84s-.84-.38-.84-.84v-2.53h-11.79v2.53c0,.47-.38.84-.84.84s-.84-.38-.84-.84v-2.53h-3.44l-1.54,18.53ZM10.11,10.11h11.79v-2.53c0-3.25-2.64-5.89-5.89-5.89s-5.89,2.64-5.89,5.89v2.53Z"></path>
        </svg>
    )
}